import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLAnchorElement> {
  connect(): void {
    window.open(this.element.href, '_blank')
  }
}
